import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {Role} from "../../../dip/role";
import {DipColumn} from "../../../dip/dip-column";
import {RoleService} from "../../../services/role.service";
import {DistributorGroupFormComponent} from "./distributor-group-form/distributor-group-form.component";
import {OrganizationUserGroupService} from "../../../services/organization-user-group.service";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-distributor-group',
  templateUrl: './distributor-group.component.html'
})
export class DistributorGroupComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('distributor.groups.grid_title');
  prodGridToolbarButtonsStatus = {
    isAddButtonDisabled: {
      role: [Role.ROLE_DISTRIBUTOR_ADMIN],
      disabled: !this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN])
    },
    isEditButtonShown: {
      role: [Role.ROLE_DISTRIBUTOR_ADMIN],
      disabled: !this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN])
    },
    isRemoveButtonDisabled: {
      role: [Role.ROLE_DISTRIBUTOR_ADMIN],
      disabled: !this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN])
    }
  };
  @Input() distributor: number = null;
  override prodGridForm = {
    component: DistributorGroupFormComponent,
    style: {height: '55%', width: '75%'},
    editStyle: {height: '55%', width: '75%'},
    extraData: {distributor: null},
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'userGroup.name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'userGroup.description', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'permissions',
      type: ProdGridColumnType.STRING,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false
    }),
    DipColumn.get({
      property: 'userGroup.users',
      type: ProdGridColumnType.STRING,
      transform: {transform: ProdGridColumnTransforms.ARRAY_JOIN, option: 'username'},
      sortable: false
    })
  ];

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    override prodGridDataService: OrganizationUserGroupService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private roleService: RoleService,
    private translate: TranslateService) {
      super(changeDetectorRef);
      organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.prodGridForm.extraData.distributor = this.distributor;
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, new HttpFilterParam({
      property: 'organization',
      operator: 'eq',
      value: this.distributor
    })));
  }
}
